import React from "react";
import { TemplateElevenResumeSection } from "./common";
import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "../ResumePDF/common";

const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateElevenResumeSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText>{summary}</ResumePDFText>}
      </View>
    </TemplateElevenResumeSection>
  );
};

export default Summary;
